import { RadioGroupOption, RadioGroupOptions } from "@msys/ui";
import {
  FormControl,
  FormGroup,
  FormHelperText,
  FormLabel,
  FormLabelProps,
  RadioGroup as MuiRadioGroup,
} from "@mui/material";
import { useField } from "formik";
import React from "react";

interface Props {
  name: string;
  label?: React.ReactNode;
  labelColor?: FormLabelProps["color"];
  disabled?: boolean;
  condensed?: boolean;
  inline?: boolean;
  helperText?: string;
  trueLabel: string;
  falseLabel: string;
}

export const RadioBooleanField = ({
  name,
  label,
  labelColor,
  disabled,
  inline = false,
  condensed = true,
  helperText,
  trueLabel,
  falseLabel,
}: Props) => {
  const [inputProps, metaProps, helperProps] = useField<boolean>(name);

  const options: RadioGroupOption<string>[] = [
    { value: "true", label: trueLabel },
    { value: "false", label: falseLabel },
  ];

  const stringValue = inputProps.value === true ? "true" : "false";

  return (
    <FormControl
      component="fieldset"
      variant="standard"
      disabled={disabled}
      error={Boolean(metaProps.error)}
    >
      {label && (
        <FormLabel component="legend" color={labelColor} sx={{ mb: 1 }}>
          {label}
        </FormLabel>
      )}
      <FormGroup>
        <MuiRadioGroup
          name={name}
          value={stringValue}
          onChange={(event, value) => helperProps.setValue(value === "true")}
          row={inline}
        >
          <RadioGroupOptions
            disabled={disabled}
            inline={inline}
            condensed={condensed}
            options={options}
          />
        </MuiRadioGroup>
      </FormGroup>
      {(metaProps.error ?? helperText) ? (
        <FormHelperText>{metaProps.error ?? helperText}</FormHelperText>
      ) : null}
    </FormControl>
  );
};
